<template>
  <div class="share_bg" v-if="realName">
    <van-image class="share_icon" src="static/imgs/share_logo.png" width="73" height="88"/>
    <van-image class="share_title" src="static/imgs/share_title.png" width="193" height="14"/>
    <van-image class="share_phone" src="static/imgs/share_phone.png" width="27" height="33"/>
    <a :href="'tel:'+phone">
      <div class="share_box">
        <div class="share_phone_text">{{phone}}</div>
        <div class="share_username_text">{{realName}}</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone:'',
      realName:''
    }
  },
  mounted() {
    if (this.isShare) {
      var url = decodeURIComponent(window.location.href)
      if (url.indexOf("?") >= 0) {
        var params = [], h;

        //indexOf方法可从链接中查找“？”首次出现位置；
        //slice方法可从已有的数组中返回选定的元素。
        //split方法用于把一个字符串分割成字符串数组。
        var hash = url.slice(url.indexOf("?") + 1).split('&');
        for (var i = 0; i < hash.length; i++) {
          h = hash[i].split("=");
          params[h[0]] = h[1];
        }

        if(params.phone) {
          this.phone = params.phone
        } 
        if (params.nbyg) {
          this.realName = params.nbyg
        }
      }
    } else {
      this.phone = localStorage.getItem("phone")
      this.realName = localStorage.getItem("nbygName")
    }
  }
}
</script>

<style scoped>
.share_bg {
  width: 100%;
  background-image: url('../../../static/imgs/share_bg.png');
  background-size: 100% 100%;
  height: 157px;
  position: relative;
  margin-top: 30px;
} 
.share_icon {
  position: absolute;
  left: 10px;
  top: 14px;
  z-index: 2;
}
.share_box {
  position: absolute;
  height: 57px;
  left: 27px;
  top: 37px;
  right: 10px;
  background-color: #ffffff;
  border-radius: 13px;
  z-index: 1;
}
.share_title {
  position: absolute;
  left: 89px;
  top: 17px;
}
.share_phone {
  position: absolute;
  right: 31px;
  top: 49px;
  z-index: 2;
}
.share_phone_text {
  font-size: 15px;
  color: #0071EE;
  position: absolute;
  left: 60px;
  top: 10px;
}
.share_username_text {
  font-size: 12px;
  color: #858585;
  position: absolute;
  left: 60px;
  top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/share/shareCommonPage.vue